import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState('');
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (name: string, url: string) => {
    setSelected(name);
    setIsOpen(false);
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="categories" className="relative w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-4">
            Browse Sugargoo Spreadsheet Categories
          </h2>
          <p className="text-foreground-500 max-w-xl mx-auto text-sm md:text-base">
            Select a category below to discover curated product finds on our main website. Every category is organized for quick and easy browsing.
          </p>
        </div>

        <div className="max-w-md mx-auto" ref={dropdownRef}>
          <div className="relative">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="w-full flex items-center justify-between px-6 py-4 bg-background-100 border border-background-300 rounded-xl text-foreground-800 font-medium cursor-pointer hover:border-primary-300 transition-all duration-200"
            >
              <span className={selected ? 'text-foreground-800' : 'text-foreground-400'}>
                {selected || 'Select a product category...'}
              </span>
              {isOpen ? (
                <i className="ri-arrow-up-s-line text-foreground-400 transition-transform duration-200"></i>
              ) : (
                <i className="ri-arrow-down-s-line text-foreground-400 transition-transform duration-200"></i>
              )}
            </button>

            {isOpen && (
              <div className="absolute z-50 w-full mt-2 bg-white border border-background-200 rounded-xl overflow-hidden animate-scale-in max-h-[420px] overflow-y-auto">
                {categories.map((cat) => (
                  <button
                    key={cat.name}
                    onClick={() => handleSelect(cat.name, cat.url)}
                    className="w-full text-left px-6 py-3.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 cursor-pointer transition-colors duration-150 flex items-center justify-between group border-b border-background-100 last:border-b-0"
                  >
                    <span>{cat.name}</span>
                    <i className="ri-external-link-line text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
                  </button>
                ))}
              </div>
            )}
          </div>
          <p className="text-xs text-foreground-400 mt-3 text-center">
            Clicking a category will open it in a new tab on kaspreadsheet.com
          </p>
        </div>
      </div>
    </section>
  );
}